import css from 'styled-jsx/css'
import { colors, fontSizes, fontWeights, measurements } from 'theme'

export default css`
  .property-interested-container {
    margin: 0 auto;
    max-width: 30rem;
    min-width: 19rem;
  }
  .property-interested-body {
    position: relative;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    display: flex;
    cursor: pointer;
  }

  .rounded-corners {
    border-radius: ${measurements.borderRadius};
  }

  .property-interested-container .main-property-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
    position: relative;
    transition: all 0.2s;
  }

  .property-interested-container .main-property-image.mask-blur-image {
    filter: blur(3px) grayscale(1);
  }

  .controls-top {
    position: absolute;
    top: 0.5rem;
  }
  .controls-top.controls-liked {
    right: 0.5rem;
    display: flex;
    width: 6rem;
    justify-content: space-between;
    flex-direction: row-reverse;
  }
  .offer-button {
    left: 1rem;
    top: 1rem;
  }

  .rejected-message {
    margin: 0;
    color: ${colors.white};
    padding: 0 1rem;

    bottom: 15%;
  }
  .rejected-message .title {
    margin-top: 0;
    margin-bottom: 0.4rem;
    color: ${colors.white};
  }
  .rejected-message p {
    margin: 0;
  }

  .details {
    position: absolute;
    bottom: 0.5rem;
    right: 1rem;
    left: 1rem;

    color: ${colors.white};
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .left-details {
    max-width: 50%;
  }

  .price,
  .address {
    margin: 0;
  }

  .price {
    font-size: ${fontSizes.h4};
    font-weight: ${fontWeights.semiBold};
  }

  .address {
    font-size: ${fontSizes.small};
  }

  .controls-top.offer-button :global(.offer-success-label > i) {
    margin-right: 0.3rem;
  }
`

export const basePropertyCardStyles = css`
  .base-property-interested-container {
    margin: 0 auto;
  }

  .rounded-corners {
    border-radius: ${measurements.borderRadius};
  }

  .base-property-interested-container .main-property-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
    position: relative;
    transition: all 0.2s;
  }

  .base-property-interested-container .header {
    color: ${colors.white};
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
  }
  .base-property-interested-container .center-content {
    color: ${colors.white};
    position: absolute;
    top: 33%;
    bottom: 33%;
    left: 0;
    right: 0;
  }
  .base-property-interested-container .details {
    color: ${colors.white};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
`

export const controlLikedStyles = css`
  .liked-button :global(.liked-icon) {
      transition: all 0.3s;
      font-size: 2.2rem;
    }
  .liked-button :global(.liked-icon.is-liked) {
    color: ${colors.danger};
  }
  .nex-btn-empty :global(.control-icon) {
    color: ${colors.white};
  }
`

export const propertyInterestedListStyles = css`
  ul.property-interested-list-container {
    display: grid;
    justify-content: center;
    grid-gap: 1rem;
    grid-template-columns: repeat(auto-fit, minmax(19rem, 22rem));
  }
  ul.property-interested-list-container,
  li.property-interested-list-item {
    padding: 0;
  }
  li.property-interested-list-item {
    list-style: none;
  }
`

export const selectedCardStyles = css`
  .selected-property-card-container {
    height: 100%;
    position: relative;
  }

  .details {
    text-align: center;
    margin-bottom: 1rem;
  }
  .details p {
    margin: 0;
  }
  .details .price {
    margin-bottom: 0.4rem;
    font-size: ${fontSizes.h5};
    font-weight: ${fontWeights.semiBold};
  }
  .address {
    font-size: ${fontSizes.small};
  }
`

export const selectedCardControlsStyles = css`
  .selected-card-controls {
    width: 100%;
    display: flex;
    padding: 0.5rem 0.5rem 0;
    justify-content: space-between;
  }
  .selected-card-controls span {
    margin-left: 0.5rem;
  }

  .selected-card-controls :global(button i) {
    margin: 0;
  }
`